import { Injectable } from '@angular/core';
import { Feature, FeatureFlag } from 'app/models/feature.models';

@Injectable({
  providedIn: 'root',
})
export class FeatureService {
  // TODO: we should probably load these from env config?
  private featureFlags: FeatureFlag = {
    [Feature.PERSONAL_INFO]: false,
  };

  setFeatureFlag(feature: Feature, value: boolean) {
    this.featureFlags[feature] = value;
  }

  isFeatureEnabled(key: Feature): boolean {
    return this.featureFlags[key];
  }
}
